import React from 'react';
import { ContentCards } from '@hz-design-system/web-ui';

import FeedItemSkeleton from './FeedItemSkeleton';
import FEED_ITEMS_PER_PAGE from '../../constants/feedItemsPerPage';

type TFeedItemListSkeleton = {
  itemsCount?: number;
};

const FeedItemListSkeleton = ({ itemsCount = FEED_ITEMS_PER_PAGE }: TFeedItemListSkeleton) => (
  <ContentCards kind="grid">
    {Array(itemsCount)
      .fill(true)
      .map((_, index) => (
        <FeedItemSkeleton key={index} />
      ))}
  </ContentCards>
);

export default FeedItemListSkeleton;
